import { ChangeDetectionStrategy, Component } from '@angular/core'
import { ControlContainer, FormGroupDirective, ReactiveFormsModule } from '@angular/forms'
import { InputText } from 'primeng/inputtext'
import { IftaLabel } from 'primeng/iftalabel'
import { AlbertBaseControlDirective } from '@directives/albert-base-control.directive'

@Component({
  selector: 'albert-input',
  standalone: true,
  imports: [ReactiveFormsModule, InputText, IftaLabel],
  templateUrl: './albert-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  viewProviders: [
    {
      provide: ControlContainer,
      useExisting: FormGroupDirective
    }
  ]
})
export class AlbertInputComponent extends AlbertBaseControlDirective {}
